import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function Instructor() {
  const [stats, setStats] = useState(null);
  const [certs, setCerts] = useState([]);

  useEffect(() => {
    (async () => {
      const [s, c] = await Promise.all([api.get("/admin/stats"), api.get("/admin/certificates")]);
      setStats(s.data);
      setCerts(c.data);
    })();
  }, []);

  return (
    <div className="p-6 lg:p-10 max-w-7xl" data-testid="instructor-page">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Instructor</div>
      <h1 className="font-display text-4xl font-bold tracking-tight text-slate-950 mt-1">Cohort performance</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">
        Track quiz attempts, pass rates per module, and certificates issued across the cohort.
      </p>

      {stats && (
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            ["Trainees", stats.trainees, "trainees"],
            ["Quiz Attempts", stats.quiz_attempts, "attempts"],
            ["Quizzes Passed", stats.quizzes_passed, "passed"],
            ["Certificates", stats.certificates_issued, "certs"],
          ].map(([l, v, k]) => (
            <div key={k} data-testid={`instructor-kpi-${k}`} className="border border-slate-200 rounded-sm p-5 bg-white">
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">{l}</div>
              <div className="font-display font-black text-3xl tracking-tighter mt-3 text-slate-950">{v}</div>
            </div>
          ))}
        </div>
      )}

      {stats?.course_breakdown?.length > 0 && (
        <div className="mt-10">
          <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">By module</h2>
          <div className="mt-3 border border-slate-200 rounded-sm overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-[0.2em] font-bold text-slate-500">
                <tr>
                  <th className="text-left p-4">Module</th>
                  <th className="text-right p-4">Attempts</th>
                  <th className="text-right p-4">Passed</th>
                  <th className="text-right p-4">Pass rate</th>
                </tr>
              </thead>
              <tbody>
                {stats.course_breakdown.map((c) => {
                  const rate = c.attempts ? Math.round((c.passed / c.attempts) * 100) : 0;
                  return (
                    <tr key={c.course_id} className="border-t border-slate-200">
                      <td className="p-4 font-semibold text-slate-900">{c.title}</td>
                      <td className="p-4 text-right">{c.attempts}</td>
                      <td className="p-4 text-right">{c.passed}</td>
                      <td className="p-4 text-right font-mono">{rate}%</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="mt-10">
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Certificates issued</h2>
        <div className="mt-3 border border-slate-200 rounded-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-[0.2em] font-bold text-slate-500">
              <tr>
                <th className="text-left p-4">Trainee</th>
                <th className="text-left p-4">Email</th>
                <th className="text-left p-4">Credential ID</th>
                <th className="text-right p-4">Issued</th>
              </tr>
            </thead>
            <tbody>
              {certs.length === 0 && (
                <tr><td colSpan={4} className="p-6 text-slate-500 text-center">No certificates issued yet.</td></tr>
              )}
              {certs.map((c) => (
                <tr key={c.certificate_id} className="border-t border-slate-200">
                  <td className="p-4 font-semibold text-slate-900">{c.user_name}</td>
                  <td className="p-4 text-slate-700">{c.user_email}</td>
                  <td className="p-4 font-mono text-xs text-slate-700">{c.certificate_id}</td>
                  <td className="p-4 text-right text-slate-700">{c.issued_at?.slice(0,10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
